/**
 * Generated from FreePlayMenuLayout.fla
 */
export function FreePlayMenuLayout(this: IFreePlayMenuLayout) {
	const bg = this.bg;
	FreePlayMenuLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const flyingButton = this.flyingButton;
	FreePlayMenuLayout_flyingButton.call(this.flyingButton);
	flyingButton.x = 512;
	flyingButton.y = 330.5;
	flyingButton.width = 369.00;
	flyingButton.height = 153.50;
	if (flyingButton.onLayout) flyingButton.onLayout();
	const restStopButton = this.restStopButton;
	FreePlayMenuLayout_restStopButton.call(this.restStopButton);
	restStopButton.x = 512;
	restStopButton.y = 504.5;
	restStopButton.width = 369.00;
	restStopButton.height = 153.50;
	if (restStopButton.onLayout) restStopButton.onLayout();
	const buttonfive = this.buttonfive;
	FreePlayMenuLayout_buttonfive.call(this.buttonfive);
	buttonfive.x = 181.5;
	buttonfive.y = 331.05;
	buttonfive.width = 321.00;
	buttonfive.height = 145.50;
	if (buttonfive.onLayout) buttonfive.onLayout();
	const buttonseven = this.buttonseven;
	FreePlayMenuLayout_buttonseven.call(this.buttonseven);
	buttonseven.x = 512.5;
	buttonseven.y = 331.05;
	buttonseven.width = 321.00;
	buttonseven.height = 145.50;
	if (buttonseven.onLayout) buttonseven.onLayout();
	const buttonnine = this.buttonnine;
	FreePlayMenuLayout_buttonnine.call(this.buttonnine);
	buttonnine.x = 842.5;
	buttonnine.y = 331.05;
	buttonnine.width = 321.00;
	buttonnine.height = 145.50;
	if (buttonnine.onLayout) buttonnine.onLayout();
	return this;
}
function FreePlayMenuLayout_bg(this: IFreePlayMenuLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-bg@2x.jpg", 0.500, 0.500);
	return this;
}
function FreePlayMenuLayout_flyingButton(this: IFreePlayMenuLayout_flyingButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-mainmenu-training-flighttrainging-btn.png", 0.500, 0.500);
	return this;
}
function FreePlayMenuLayout_restStopButton(this: IFreePlayMenuLayout_restStopButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-mainmenu-training-reststop-btn.png", 0.500, 0.500);
	return this;
}
function FreePlayMenuLayout_buttonfive(this: IFreePlayMenuLayout_buttonfive) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain5.png", 0.500, 0.500);
	return this;
}
function FreePlayMenuLayout_buttonseven(this: IFreePlayMenuLayout_buttonseven) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain7.png", 0.500, 0.500);
	return this;
}
function FreePlayMenuLayout_buttonnine(this: IFreePlayMenuLayout_buttonnine) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-end-btn-playagain9.png", 0.500, 0.500);
	return this;
}
interface IFreePlayMenuLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IFreePlayMenuLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IFreePlayMenuLayoutSprite extends IFreePlayMenuLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IFreePlayMenuLayoutText extends IFreePlayMenuLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IFreePlayMenuLayoutPolygon extends Array<number> {
}
interface IFreePlayMenuLayout {
	readonly bg: IFreePlayMenuLayout_bg;
	readonly flyingButton: IFreePlayMenuLayout_flyingButton;
	readonly restStopButton: IFreePlayMenuLayout_restStopButton;
	readonly buttonfive: IFreePlayMenuLayout_buttonfive;
	readonly buttonseven: IFreePlayMenuLayout_buttonseven;
	readonly buttonnine: IFreePlayMenuLayout_buttonnine;
}
interface IFreePlayMenuLayout_bg extends IFreePlayMenuLayoutSprite {
}
interface IFreePlayMenuLayout_flyingButton extends IFreePlayMenuLayoutSprite {
}
interface IFreePlayMenuLayout_restStopButton extends IFreePlayMenuLayoutSprite {
}
interface IFreePlayMenuLayout_buttonfive extends IFreePlayMenuLayoutSprite {
}
interface IFreePlayMenuLayout_buttonseven extends IFreePlayMenuLayoutSprite {
}
interface IFreePlayMenuLayout_buttonnine extends IFreePlayMenuLayoutSprite {
}
